import type {
  useInteractions,
  UseFloatingReturn,
} from "@floating-ui/react"
import type { RefObject } from "react"
import { createContext } from "react"
import type { Reading } from "src/types"

export interface TooltipContextValue extends UseFloatingReturn, ReturnType<typeof useInteractions> {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  reading?: Reading;
  arrow: RefObject<HTMLDivElement | null>;
}

type ContextType = TooltipContextValue | null
export const TooltipContext = createContext<ContextType>(null)
